function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Dark Logo");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "white",
  stroke: "none",
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M31,30 C24.9248678,30 20,25.0751322 20,19 C20,12.9248678 24.9248678,8 31,8 C37.0751322,8 42,12.9248678 42,19 C42,25.0751322 37.0751322,30 31,30 Z M31,56 C24.9248678,56 20,51.0751322 20,45 C20,38.9248678 24.9248678,34 31,34 C37.0751322,34 42,38.9248678 42,45 C42,51.0751322 37.0751322,56 31,56 Z M69,93 C62.9248678,93 58,88.0751322 58,82 C58,75.9248678 62.9248678,71 69,71 C75.0751322,71 80,75.9248678 80,82 C80,88.0751322 75.0751322,93 69,93 Z",
  id: "Combined-Shape"
}), React.createElement("path", {
  d: "M33.2891527,77.5858159 L22.7999324,66.8825055 C21.7420728,65.8030545 21.7337883,64.0782582 22.7812298,62.988695 C23.787935,61.9415064 25.4529448,61.9086881 26.5001334,62.9153932 C26.5197817,62.9342819 26.5391352,62.9534748 26.5581868,62.9729651 L40.842216,77.5858159 L26.5500571,92.2069837 C25.5348139,93.245598 23.8698335,93.264544 22.8312192,92.2493008 C22.8143314,92.2327931 22.7976668,92.2160586 22.7812298,92.1991019 C21.7346388,91.1194208 21.7382291,89.4026444 22.7893268,88.3273502 L33.2891527,77.5858159 Z M69.0322568,7 C75.0895741,7 80,11.9104259 80,17.9677432 L80,53.2157026 C80,59.2730199 75.0895741,64.1834458 69.0322568,64.1834458 C62.9749394,64.1834458 58.0645135,59.2730199 58.0645135,53.2157026 L58.0645135,17.9677432 C58.0645135,11.9104259 62.9749394,7 69.0322568,7 Z",
  id: "Combined-Shape"
}), React.createElement("text", {
  id: "dark",
  fontFamily: "MankSans",
  fontSize: 70,
  fontWeight: "normal",
  letterSpacing: 1.5
}, React.createElement("tspan", {
  x: 104,
  y: 91
}, "dark")));

var SvgBgLogo = function SvgBgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 250 100",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bgLogo.f06f2515.svg";
export { ForwardRef as ReactComponent };